import Navbar from '../../navbar/Navbar';
import Footer from '../../footer/Footer';
import BennaCsdHod from '../cseDepartmentLinks/cseD/beena-bethel-csd-hod.png'
import MCALeftTab from './MCALeftTab'

const MCAHOD = () => {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 pe-lg-4 order-2 order-lg-1">

                            <MCALeftTab />
                        </div>
                       <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>
                                    Master of Computer Applications (MCA)
                                </h2>

                                <div className='pt-3'>
                                    <div class="">
                                        <h5> HOD Profile</h5>
                                        <div class="pt-3">
                                            <img src={BennaCsdHod} width={100} className='img-fluid' alt='cse-hod' loading='lazy' />
                                            <p className='pt-3'>
                                                <h6>Dr G N Beena Bethel (MCA HOD) </h6>
                                                Dr. G N Beena Bethel is presently working as a Professor and HOD both in the departments of CSE (Data Science) and Master of computer Applications (MCA) at Sridevi Women’s Engineering College, Hyderabad, Telangana, India. She has received her Ph. D (CSE) in the area of Datamining from Jawaharlal Nehru Technological University, Hyderabad. She has over Twenty-Three years of academic and research experience. Her research interests are Datamining, Data analytics, Machine Learning and Quantum Computing. 
                                            </p>
                                            <p>
                                                She has published 35 papers in Scopus indexed International Journal and Conferences, and also published four patents. She has authored two text books. She is a life member of CSI, IEI and IAENG. She is an active participant of NPTEL certifications in various subjects. Dr. G N Beena Bethel has received Research Excellence Award, Best Researcher Award and Best Teacher Award from various recognized institutions.  
                                            </p>
                                        </div>
                                    </div>
                                    {/* <div className='pt-2'>
                                        <div className="apply-list">
                                            <h6>Educational Qualifications:</h6>
                                            <ul className="pt-2">
                                                <li><i className="fas fa-check-circle"></i> B.Tech in CSE from Jawaharlal Nehru Technological University in 2003.</li>
                                                <li><i className="fas fa-check-circle"></i> M.Tech in CSE from Jawaharlal Nehru Technological University, Hyderabad in 2008.</li>
                                                <li><i className="fas fa-check-circle"></i> PhD in CSE from Jawaharlal Nehru Technological University, Hyderabad in 2019.</li>
                                            </ul>
                                        </div>
                                    </div>


                                    <div className='pt-2'>
                                        <div className="apply-list">
                                            <h6>Achievements:</h6>
                                            <ul className="pt-2">
                                                <li><i className="fas fa-check-circle"></i> Published more than 30 papers in National & International Conferences & Journals.</li>
                                                <li><i className="fas fa-check-circle"></i> Patents Filed: 03</li>
                                                <li><i className="fas fa-check-circle"></i> Number of books published: 01</li>
                                                <li><i className="fas fa-check-circle"></i> Number of book chapters published: 01</li>
                                                <li><i className="fas fa-check-circle"></i> Attended Various Workshops & Conferences</li>
                                                <li><i className="fas fa-check-circle"></i> Life member of CSI, IEI (Institution of Engineers, India), and IAENG.</li>
                                                <li><i className="fas fa-check-circle"></i> Convener for Many Workshops and National Level Technical Fests.</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='pt-2'>
                                        <div className="apply-list">
                                            <h6>Awards:</h6>
                                            <ul className="pt-2">
                                                <li><i className="fas fa-check-circle"></i> Best Researcher's Award</li>
                                                <li><i className="fas fa-check-circle"></i> Research Excellence Award</li>
                                                <li><i className="fas fa-check-circle"></i> Best Teacher's Award</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='pt-2'>
                                        <div className="apply-list">
                                            <h6>Positions Handled:</h6>
                                            <ul className="pt-2">
                                                <li><i className="fas fa-check-circle"></i> Institution Level - Worked as Overall Coordinator for Academic Affairs.</li>
                                                <li><i className="fas fa-check-circle"></i> Department Level - Incharge as Dept. Examination Coordinator for CSE Dept and presently HOD of CSD Dept.</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='pt-2'>
                                        <div className="apply-list">
                                            <h6>Subjects Handled:</h6>
                                            <ul className="pt-2">
                                                <li><i className="fas fa-check-circle"></i> Python Programming (PP)</li>
                                                <li><i className="fas fa-check-circle"></i> Datawarehousing and Datamining (DWDM)</li>
                                                <li><i className="fas fa-check-circle"></i> Software Engineering (SE)</li>
                                                <li><i className="fas fa-check-circle"></i> Digital Logic Design (DLD)</li>
                                                <li><i className="fas fa-check-circle"></i> C & Datastructures (C & DS)</li>
                                                <li><i className="fas fa-check-circle"></i> Computer Networks (CN)</li>
                                                <li><i className="fas fa-check-circle"></i> Data Communication (DC)</li>
                                                <li><i className="fas fa-check-circle"></i> Discrete Structures and Graph Theory (DSGT)</li>
                                                <li><i className="fas fa-check-circle"></i> Switching Theory and Logic Design (STLD)</li>
                                                <li><i className="fas fa-check-circle"></i> Information Technology and Numerical Methods (ITNM)</li>
                                                <li><i className="fas fa-check-circle"></i> Object Oriented Analysis and Design (OOAD)</li>
                                                <li><i className="fas fa-check-circle"></i> Software Project Management (SPM)</li>
                                                <li><i className="fas fa-check-circle"></i> Object Oriented Software Engineering (OOSE - AICTE Recommended Syllabus)</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='pt-2'>
                                        <div className="apply-list">
                                            <h6>M.Tech Subjects:</h6>
                                            <ul className="pt-2">
                                                <li><i className="fas fa-check-circle"></i> Unified Modeling Language (UML)</li>
                                                <li><i className="fas fa-check-circle"></i> Advanced Datamining (ADM)</li>
                                                <li><i className="fas fa-check-circle"></i> Data Analytics (DA)</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className='pt-2'>
                                        <div className="apply-list">
                                            <h6>Hobbies:</h6>
                                            <ul className="pt-2">
                                                <li><i className="fas fa-check-circle"></i> Cooking</li>
                                                <li><i className="fas fa-check-circle"></i> Gardening</li>
                                                <li><i className="fas fa-check-circle"></i> Listening to Music</li>
                                            </ul>
                                        </div>
                                    </div> */}


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default MCAHOD;
